// A lead id is a positive whole number (route params arrive as strings).
export const isLeadId = (value) => (typeof value === 'number' || typeof value === 'string') && /^[1-9]\d*$/.test(String(value));
